import { Box, Typography, Button } from "@mui/material";
import { FC } from "react";
import { Link } from "react-router";

export interface BlogCardProps {
  image: string;
  title: string;
  description: string;
  to: string;
}

export const BlogCard: FC<BlogCardProps> = ({ image, title, description, to }) => (
  <Box
    className="blog-card"
    sx={{
    
    }}
  >
    <Box
      component="img"
      src={image}
      alt={title}
      sx={{ width: "100%", height: 160, objectFit: "cover", mb: "24px" , borderRadius: "6px" }}
    />
    <Box sx={{ flex: 1, display: "flex", flexDirection: "column", }}>
      <Typography
        variant="h6"
        color="text.primary"
        fontWeight="bold"
        sx={{ mb: "8px",color:"#111827" }}
      >
        {title}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          mb: "20px",
          display: '-webkit-box',
          WebkitLineClamp: 3,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'normal',
          color:"#6B7280",
        }}
      >
        {description}
      </Typography>
      <div>
        <Button
          component={Link}
          to={to}
          color={"black" as any}
          className="btn-outline font-size-3"
          variant="outlined"
        >
          Read More
        </Button>
      </div>
    </Box>
  </Box>
); 
